<template>
  <div class="user-notification">
    <div class="date">{{ formattedDate }}</div>
    <div class="details">
      <font-awesome-icon class="tag-icon" :icon="{ prefix: 'fas', iconName: 'list' }" />
      The list "<router-link :to="listRoute" @click.native="clearNotification">{{
        details.listTitle
      }}</router-link
      >" has been changed:
      <ul>
        <li v-if="details.nameChanged">The list name has been updated</li>
        <li v-if="details.descriptionChanged"> The list's description has been updated </li>
        <li v-if="details.facebookChanged"> The Facebook group link has been updated </li>
        <li v-if="details.repImageChanged">
          The list representative image thumbnail has been updated
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped lang="scss">
.user-notification {
  ul {
    padding-left: 3rem;
  }
}
</style>

<script>
import AbstractNotificationDetail from './AbstractNotificationDetail'

export default {
  name: 'CollabListChanged',
  extends: AbstractNotificationDetail,
  computed: {
    listRoute() {
      return {
        name: 'List',
        params: { id: this.details.listId },
      }
    },
  },
}
</script>
